import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory } from 'react-router-dom';

import withSelectedEnrolment from '../../../common/hub/NewWithSelectedEnrolment';
import ContactFormLayout from '../../../common/hub/ContactFormLayout';
import { useRadioGroupProps, RadioGroup } from '../../../components/RadioGroup/RadioGroup';
import { useTextAreaProps, TextArea } from '../../../components/TextArea/TextArea';
import { submitCaseToSF } from '../../../actions/hub/hubContactPageActions';
import FormSubHeading from '../../../components/hub/contact/FormSubHeading';
import ErrorBlock from '../../../common/ErrorBlock';
import { PATH_HUB_CR_SUBMIT_CASE_SUCCESS, PATH_HUB_CR_FEEDBACK } from '../../../util/pagePath';
import { Button } from '@cluey/cluey-components';

const groupName = 'contact-form-feedback';
const radios = [
  {
    text: 'Session',
    value: 'Session',
    key: `${groupName}-category-1`,
  },
  {
    text: 'Tutor',
    value: 'Tutor',
    key: `${groupName}-category-2`,
  },
  {
    text: 'Service',
    value: 'Service',
    key: `${groupName}-category-3`,
  },
  {
    text: 'Other',
    value: 'Other',
    key: `${groupName}-category-4`,
  },
];

const FormFeedback = ({ selectedEnrolment, isSubmitting, submitError, errorMsg, submit }) => {
  const radioGroupProps = useRadioGroupProps({ groupName, radios });
  const textAreaProps = useTextAreaProps({
    id: `${groupName}-textarea`,
    labelText: 'What would you like to tell us?',
  });

  const { enrolmentId, studentSfid, student, subject } = selectedEnrolment;
  const history = useHistory();
  const onClickHandler = () => {
    const caseType = 'Feedback';
    const caseCategory = radioGroupProps.selectedRadio;

    submit({
      uniqueEnrolmentId: enrolmentId,
      message: `Customer has provided feedback on ${caseCategory}. Details: ${textAreaProps.value}`,
      caseSubject: `Contact Request - ${caseType} - ${caseCategory}`,
      caseType,
      caseCategory,
      onSubmitSuccess: () => {
        history.push(PATH_HUB_CR_SUBMIT_CASE_SUCCESS, {
          firstName: student,
          studentId: studentSfid,
          header: 'Feedback submitted',
          message: `Your feedback on ${student}'s ${subject} enrolment has been submitted successfully. We'll be in touch soon.`,
        });
      },
    });
  };

  return (
    <ContactFormLayout selectedEnrolment={selectedEnrolment}>
      <div className="px-5 pt-5 lg:px-20 lg:pt-12">
        <FormSubHeading />
        {submitError && errorMsg && <ErrorBlock errorMsg={errorMsg} />}
        <form>
          <RadioGroup {...radioGroupProps} className="mb-9" />
          <TextArea {...textAreaProps} className="mb-7" />
          <div className="mb-4 text-center tracking-normal lg:mb-8">
            <Button
              size="lg"
              disabled={!radioGroupProps.selectedRadio || !textAreaProps.value || isSubmitting}
              onClick={onClickHandler}
            >
              Submit feedback
            </Button>
          </div>
        </form>
      </div>
    </ContactFormLayout>
  );
};

FormFeedback.propTypes = {
  selectedEnrolment: PropTypes.shape({
    enrolmentId: PropTypes.string.isRequired,
    studentSfid: PropTypes.string.isRequired,
    student: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
  }).isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  submitError: PropTypes.bool.isRequired,
  errorMsg: PropTypes.string.isRequired,
  submit: PropTypes.func.isRequired,
};

export default connect(
  (state) => {
    return {
      isSubmitting: state.ui.apiState.hubContactPage.isLoading,
      submitError: state.ui.apiState.hubContactPage.fetchError,
      errorMsg: state.ui.apiState.hubContactPage.errorMsg,
    };
  },
  (dispatch) => {
    return {
      submit: bindActionCreators(submitCaseToSF, dispatch),
    };
  }
)(withSelectedEnrolment(FormFeedback, null, PATH_HUB_CR_FEEDBACK));
